import { render } from "./staff-list-item.vue?vue&type=template&id=375be11b"
import script from "./staff-list-item.vue?vue&type=script&lang=js"
export * from "./staff-list-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__